import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../config/axios'
import { TeamMember, TeamMemberSyncResponse } from './types'

export const bulkSyncTeamMembers = createAsyncThunk<TeamMemberSyncResponse, File>(
  'teamMember/bulkSyncTeamMembers',
  async (file) => {
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await axios.post('/teamMember/bulkSyncTeamMembers', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      
      // The backend doesn't return teamMembers, so we need to fetch them separately
      const teamMembersResponse = await axios.get('/teamMember/getAllTeamMember')
      
      return {
        ...response.data,
        teamMembers: teamMembersResponse.data,
        filename: file.name
      }
    } catch (error: any) {
      console.error('Error bulk syncing team members:', error)
      // Preserve the backend error message for validation errors
      const errorMessage = error.response?.data?.message || error.message || 'Failed to bulk sync team members'
      throw new Error(errorMessage)
    }
  },
)

export const fetchTeamMemberInfo = createAsyncThunk<TeamMember, Partial<TeamMember>>(
  'teamMember/getTeamMemberInfo',
  async (queryParams) => {
    try {
      const params = new URLSearchParams()

      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, value.toString())
        }
      })

      const response = await axios.get(`/teamMember/getTeamMember?${params.toString()}`)
      return response.data
    } catch (error) {
      console.error('Error fetching team member info:', error)
      throw new Error('Failed to fetch team member info')
    }
  },
)

export const fetchTeamMembers = createAsyncThunk('teamMember/fetchAllTeamMembers', async () => {
  try {
    const response = await axios.get('/teamMember/getAllTeamMember')
    return response.data
  } catch (error) {
    console.error('Error fetching team members:', error)
    throw new Error('Failed to fetch team members')
  }
})

export const fetchTeamMemberPoints = createAsyncThunk(
  'teamMember/getPoints',
  async (payload: any, { rejectWithValue }) => {
    const { teamMemberEmail, teamMemberWorkdayId } = payload

    const queryParams = new URLSearchParams()
    if (teamMemberEmail) queryParams.append('teamMemberEmail', teamMemberEmail)
    if (teamMemberWorkdayId) queryParams.append('teamMemberWorkdayId', teamMemberWorkdayId)

    try {
      return axios.get(`/teamMember/getPoints?${queryParams}`).then((response) => response.data)
    } catch (error: any) {
      console.error('Error fetching team member points:', error)
      return rejectWithValue(error.response?.data || error.message)
    }
  },
)

